export const airwaysListArray = [
  {
    id: 1,
    airwayName: 'Air way name',
    fixSequence: 'Fix Sequence',
    rnp4: 'YES',
    rnp10: 'YES',
    hfRadio: 'YES',
    countryOne: 'Mexico',
  },
];

export const RNAVRNPList = [
  { itemValue: 'NONE', itemLabel: 'NONE' },
  { itemValue: 'RNP_10', itemLabel: 'RNP 10' },
  { itemValue: 'RNP_4', itemLabel: 'RNP 4' },
  { itemValue: 'RNP_1', itemLabel: 'RNP 1' },
  { itemValue: 'RNAV_5', itemLabel: 'RNAV 5' },
  { itemValue: 'RNAV_2', itemLabel: 'RNAV 2' },
  { itemValue: 'RNAV_1', itemLabel: 'RNP 1' },
  { itemValue: 'RNP_APCH', itemLabel: 'RNAV APCH' },
  { itemValue: 'RNP_AR_APCH', itemLabel: 'RNP AR APCH' },
];
